const transformErrors = ({ username, password1, password2, email }) => {
  const errors = Object.values({
    username,
    password1,
    password2,
    email,
  });
  return errors.join(' ');
};

export { transformErrors };



// WEBPACK FOOTER //
// ./src/user/utils.js